import React from 'react';

export type FloatingAlertMode = 'success' | 'warning' | 'danger' | 'info';

interface FloatingAlertProps {
    message: string;
    mode?: FloatingAlertMode;
    onClose?: () => void;
    duration?: number; // ms, opcional para autocierre
    title?: string;
}


const modeIcons: Record<FloatingAlertMode, string> = {
    success: '✅',
    warning: '⚠️',
    danger: '⚠️',
    info: 'ℹ️',
};

export const FloatingAlert: React.FC<FloatingAlertProps> = ({
    message,
    mode = 'info',
    onClose,
    duration,
    title,
}) => {
    React.useEffect(() => {
        if (duration && onClose) {
            const timer = setTimeout(onClose, duration);
            return () => clearTimeout(timer);
        }
    }, [duration, onClose]);



    return (
        <div className={`floating-alert floating-alert--${mode}`}>
            <div className='floating-alert__row'>
                <div className='floating-alert__content'>
                    {title && (
                        <h2 className='floating-alert__title'>{modeIcons[mode]} {title}</h2>
                    )}
                    <span className='floating-alert__message'>{message}</span>
                </div>
                {onClose && (
                    <button className='floating-alert__close' onClick={onClose} aria-label='Cerrar'>×</button>
                )}
            </div>
        </div>
    );
};

export default FloatingAlert;
